export default function() {

  $('.collapseCard').on('click', function(e) {

    // Set card
    let $card = $(this).closest('.Card');

    // Set whether collapsed
    let collapsed = $(this).data('collapsed');

    // Toggle collapse
    if (collapsed) {
    	$card.removeClass('minimized');
      $(this).data('collapsed', false);
    	$(this).find('.chevron-down').addClass('d-none');
    	$(this).find('.chevron-up').removeClass('d-none');

    } else {
    	$card.addClass('minimized');
      $(this).data('collapsed', true);
    	$(this).find('.chevron-up').addClass('d-none');
    	$(this).find('.chevron-down').removeClass('d-none');

    }

    // Reflow chart if present
    let $chart = $card.find('.chart').data('c3-chart');
    if ( typeof $chart !== 'undefined' ) {
      setTimeout(function() {
        $chart.flush();
      }, 100);
    }

  });


}
